import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onBeforeUnmount, computed } from 'vue';
import { useQuota } from '@ve/composables/useQuota';
import { useViewport } from "@travelata-libs/utils";
import Cookies from 'js-cookie';

interface Props {
    hotelContentTitle?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DroppedOrderBanner',
  props: {
    hotelContentTitle: null
  },
  setup(__props: any) {

const props = __props as {
    hotelContentTitle?: string;
};



const { isMobile } = useViewport();
const { quotaData, removeQuotaCookie, goToCheckout, init } = useQuota();

const tourPageElement = document.querySelector('#tourPage')

const isTourPage = tourPageElement?.getAttribute('id') === 'tourPage' || window.location.pathname.includes('/tourPage')

const isHotelOfferPage = window.location.pathname.includes('/hotels/')

const showBanner = computed(() => {
    return !!quotaData.value && !isTourPage && !isHotelOfferPage;
});

const backButtonText = 'Вернуться к бронированию';
const error = ref(null);
const hasCookieConsent = ref(false);

const hotelName = computed(() => {
    return quotaData.value?.hotelName || '';
});

const hotelCover = computed(() => {
    return quotaData.value?.hotelCover || '';
});

const countryName = computed(() => {
    return quotaData.value?.countryName || '';
});

const resortName = computed(() => {
    return quotaData.value?.resortName || '';
});

const onCloseClick = () => {
    removeQuotaCookie();
};

const onCheckoutClick = () => {
    goToCheckout();
};

const onCookieAcceptClick = (event: Event) => {
    const target = event.target as HTMLElement | null;
    if (!target) return;
    const button = target.closest('button[aria-label="Принять использование cookies"]');
    if (button) {
        hasCookieConsent.value = true;
    }
};

onMounted(async () => {
    await init();

    const cookieConsent = Cookies.get('cookieConsent');
    hasCookieConsent.value = !!cookieConsent;

    document.addEventListener('click', onCookieAcceptClick, true);
});

onBeforeUnmount(() => {
    document.removeEventListener('click', onCookieAcceptClick, true);
});

return { __sfc: true,props, isMobile, quotaData, removeQuotaCookie, goToCheckout, init, tourPageElement, isTourPage, isHotelOfferPage, showBanner, backButtonText, error, hasCookieConsent, hotelName, hotelCover, countryName, resortName, onCloseClick, onCheckoutClick, onCookieAcceptClick }
}

})